module.exports = __webpack_public_path__ + "static/img/wdjc1-5.9d59400.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdjc1-5.png
// module id = 884
// module chunks = 0